import React, { useState, useEffect, useRef } from "react";
import GetLogin from "../auth/GetLogin";
import { useRouter } from "next/router";
import { createUseStyles } from "react-jss";
import { Input, Modal, App, Button, Form, Divider, Upload, Spin, Alert } from "antd";

import UIFormNew from "../ui/forms/UIFormNew";
import { handleApplyNow } from "../../common/AuthHelper";
import { getFormatedData } from "../../common/FormFormattedData";
import { getUserInfo, singOut, Company } from "../../common/userfuctions";
import { 
  setUserData,
  setUserInfo,
  signOutEvent,
} from "../../common/userfuctions";
import {
  Login,
  CheckEmail,
  VerifyEmail,
  VerifyEmailForResetPassword,
  ResetPassword,
} from "../../pages/api/API";
import { UILink, UIText, UIButton, UIHeading } from "../ui/UIElements";
import {
  AccountSettingsSave,
  getAccountSettingsForm, uploadFile
} from "../../pages/api/modules/User";
import UIFromHeading from "../ui/forms/UIFromHeading";
import FormSkeleton from "../skeleton/FormSkeleton";
import { AddCompany } from "../employer/OnBordingModal";
import { createCompany, getCreateCompanyForm } from "../../pages/api/Employer/Employer";
import { FileOutlined, FilePdfOutlined, LoadingOutlined } from "@ant-design/icons";
import { setCookie } from "cookies-next";


const RenderLogin = ({
  setstage,
  onSubmitLogin,
  classes,
  visible,
  loading,
  onClose
}) => {
  const router = useRouter();
  const { message } = App.useApp();
  const onSignUpwithSocial = async (type, socialReponse) => {
    let employer = router.pathname.includes("/employer") ? true : false;
    if (type === "Google") {
      const res = await CheckEmail(employer, "", type, socialReponse, {
        ...socialReponse.profileObj,
      });
      if (res.Status === -1) {
        signOutEvent();
      }
      if (res.Status === 0) {
        message.error(res.Error);
      }
      if (res.Status === 1) {
        message.success("Signed In Successfully");
        setUserData({ token: res.Data.AccessToken, userInfo: res.Data.Info });
        onClose(true);
        if (
          router.pathname.includes("/employer") &&
          parseInt(res.Data?.Info?.Employer) === 1
        ) {
          router.push("/employer/home");
        } else {
          if (link) {
            handleApplyNow(JobCode);
            window.open(link, openNewTab ? "_blank" : "_self");
          }
        }
      }
    } else {
      const res = await CheckEmail(employer, "", type, socialReponse);
      if (res.Status === -1) {
        signOutEvent();
      }
      if (res.Status === 0) {
        message.error(res.Error);
      }
      if (res.Status === 1) {
        message.success("Signed In Successfully");
        setUserData({ token: res.Data.AccessToken, userInfo: res.Data.Info });
        onClose(true);
        if (
          router.pathname.includes("/employer") &&
          parseInt(res.Data?.Info?.Employer) === 1
        ) {
          router.push("/employer/home");
        } else {
          if (link) {
            handleApplyNow(JobCode);
            window.open(link, openNewTab ? "_blank" : "_self");
          }
        }
      }
    }
  };

  const inputRef = useRef();
  useEffect(() => {
    inputRef?.current?.focus()
  }, [])
  return (
    <>
      <div className={classes.authContent}>
        <div className={classes.authHeader}>
          <span className={classes.eyebrow}>Candidate Portal</span>
          <UIHeading level={2}>Welcome back</UIHeading>
          <UIText>Sign in to discover opportunities built around your career.</UIText>
        </div>
        <Form
          name="password_form"
          className="login-form"
          initialValues={{ remember: true }}
          layout="vertical"
          onFinish={onSubmitLogin}
        >
          <Form.Item
            name="email"
            label="Email"
            autoFocus={true}
            rules={[
              { required: true, message: "Please input your email!" },
            ]}
          >
            <Input
              type="email"
              className={classes.signupEmailInput}
              placeholder="you@example.com"
              ref={inputRef}
              autoComplete="email"
            />

          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: "Please input your password" },
            ]}
          >
            <Input.Password
              className={classes.signupEmailInput}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </Form.Item>

          <div className={classes.authLinks}>
          <UILink
            onClick={() => {
              setstage("email");
            }}
          >
            Create an account
          </UILink>
          <UILink
            onClick={() => {
              setstage("forgot");
            }}
          >
            Forgot Password?
          </UILink>

          </div>
          <div className={classes.primaryAction}>
              <Form.Item style={{ margin: 0 }}>
                <UIButton
                  loading={loading}
                  type="primary"
                  htmlType="submit"
                  className={classes.contine}
                >
                  Login
                </UIButton>
              </Form.Item>

          </div>
          {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '30px 0' }}>
            <div style={{ border: '1px solid #e1e1e1', width: '40%' }}></div>
            <UIHeading level={4} style={{ marginBottom: 0 }}>OR</UIHeading>
            <div style={{ border: '1px solid #e1e1e1', width: '40%' }}></div>
          </div>
          <GetLogin onLogin={onSignUpwithSocial} /> */}
        </Form>
      </div>
      
    </>
  );
}

function SignUpPopup({
  visible,
  link,
  openNewTab = false,
  onClose,
  JobCode = null,
  initialStage = "login",
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [resetFieldsUnlocked, setResetFieldsUnlocked] = useState(false);
  const [verificationCode, setverificationCode] = useState("");
  const [stage, setstage] = useState(initialStage);
  const [fields, setFields] = useState([]);
  const [seconds, setSeconds] = useState(0);
  const router = useRouter();
  const [reusmeLoading, setResumeLoading] = useState(false);
  const inputRef = useRef();
  const {message} = App.useApp();

  useEffect(() => {
    if (visible) setstage(initialStage);
  }, [visible, initialStage]);

  const onSignUpwithSocial = async (type, socialReponse) => {
    let employer = router.pathname.includes("/employer") ? true : false;
    if (type === "Google") {
      const res = await CheckEmail(employer, "", type, socialReponse, {
        ...socialReponse.profileObj,
      });
      if (res.Status === -1) {
        signOutEvent();
      }
      if (res.Status === 0) {
        message.error(res.Error);
      }
      if (res.Status === 1) {
        message.success("Signed In Successfully");
        setUserData({ token: res.Data.AccessToken, userInfo: res.Data.Info });
        onClose(true);
        if (
          router.pathname.includes("/employer") &&
          parseInt(res.Data?.Info?.Employer) === 1
        ) {
          router.push("/employer/home");
        } else {
          if (link) {
            handleApplyNow(JobCode);
            window.open(link, openNewTab ? "_blank" : "_self");
          }
        }
      }
    } else {
      const res = await CheckEmail(employer, "", type, socialReponse);
      if (res.Status === -1) {
        signOutEvent();
      }
      if (res.Status === 0) {
        message.error(res.Error);
      }
      if (res.Status === 1) {
        message.success("Signed In Successfully");
        setUserData({ token: res.Data.AccessToken, userInfo: res.Data.Info });
        onClose(true);
        if (
          router.pathname.includes("/employer") &&
          parseInt(res.Data?.Info?.Employer) === 1
        ) {
          router.push("/employer/home");
        } else {
          if (link) {
            handleApplyNow(JobCode);
            window.open(link, openNewTab ? "_blank" : "_self");
          }
        }
      }
    }
  };

  const onAddCompany = async (data) => {
    const res = await createCompany(data);
    if (res?.Status === 1) {
      message.success('Company created successfully')
      router.push("/employer/home");
    }
    else {
      message.error(res?.Error)
    }
  };
  // const onAddCompanyFormFields = async () => {
  //   const res = await getCreateCompanyForm();
  //   if (res?.Status === 1) {
  //     const data = await getFormatedData(res?.Data?.Form);
  //     setCompanyFields(data);
  //     setCompanyFormLoading(false);
  //   }
  // };

  useEffect(() => {
    if (stage == "verification") {
      seconds > 0 ? setTimeout(() => setSeconds(seconds - 1), 1000) : null;
    }
  }, [seconds]);

  useEffect(() => {
    if (stage === "basicInfo") {
      getFields();
    }
  }, [stage]);

  useEffect(() => {
    const user = getUserInfo();
    if (user) {
      if (user?.Status == 2) {
        setstage("basicInfo");
      }
    }
  }, [visible]);

  useEffect(() => {
    inputRef?.current?.focus()
  }, [visible, inputRef.current, stage])

  const getFields = async () => {
    const res = await getAccountSettingsForm({ Source: "SignUp_Step" });
    if (res.Status === -1) {
      signOutEvent();
      singOut();
      router.push("/");
    }

    if (res?.Status === 1) {
      const data = await getFormatedData(res?.Data?.Form, true, "Save");
      setFields(data);
    }
  };

  const onSignUp = async () => {
    let employer = router.pathname.includes("/employer") ? true : false;
    if (email.length < 5) {
      message.error("Email is not valid");
      return;
    }
    setLoading(true);
    try {
      const res = await CheckEmail(employer, email);
      if (res?.Status === 0) {
        message.error(res?.Error || "Sign up failed");
      } else if (res?.Status === 1 && res?.NextStepType === 0) {
        setstage("verification");
        setSeconds(60);
      } else if (res?.Status === 1 && res?.NextStepType === 1) {
        setstage("password");
      } else {
        message.error("Unexpected response. Please try again.");
      }
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  const onVerify = async () => {
    let employer = router.pathname.includes("/employer") ? true : false;

    setLoading(true);
    try {
      const res = await VerifyEmail(employer, email, verificationCode);
      if (res?.Status === -1) {
        signOutEvent();
        message.error("Session expired. Please try again.");
        return;
      }
      if (res?.Status === 0) {
        message.error(res?.Error || "Verification failed");
        return;
      }
      if (res?.Status === 1) {
        setUserData({ token: res.Data.AccessToken, userInfo: res.Data.Info }, false);
        setstage("basicInfo");
        return;
      }
      message.error("Unexpected response. Please try again.");
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  const onFinishBasicInfoForm = async (values) => {
    const employer = router.pathname.includes("/employer");
    setLoading(true);
    try {
      const response = await AccountSettingsSave({ employer, values, Source: "SignUp_Step" });

      if (response?.Status === 0) {
        message.error(response?.Error || "Save failed");
        return;
      }
      if (response?.Status === 1) {
        message.success("Signed In Successfully");

        if (response?.Employer) {
          const EmployerData = response?.EmployerData;
          setUserData({ token: EmployerData?.AccessToken, userInfo: EmployerData?.Info }, false);
          router.push("/employer/home");
          return;
        }

        setUserInfo(response?.Data, true);
        onClose(true);

        if (parseInt(response?.Data?.Employer) === 1) {
          router.push("/employer/home");
          return;
        }

        await router.push("/profile?onboarding=complete-profile");
        return;
      }

      message.error("Unexpected response. Please try again.");
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinisPassowrdForm = async (values) => {
    setLoading(true);
    try {
      const response = await Login(email, values.password);

      if (response?.Status === -1) {
        signOutEvent();
        message.error("Session expired. Please try again.");
        return;
      }

      if (response?.Status === 0) {
        message.error(response?.Error || "Login failed");
        return;
      }

      if (response?.Status === 1 && response?.Data?.Info?.Status === "1") {
        message.success("Signed In Successfully");
        setUserData({
          token: response.Data.AccessToken,
          userInfo: response.Data.Info,
        });
        onClose(true);

        if (router.pathname.includes("/employer") && parseInt(response?.Data?.Info?.Employer) === 1) {
          router.push("/employer/home");
        } else if (link) {
          handleApplyNow(JobCode);
          window.open(link, openNewTab ? "_blank" : "_self");
        }
        return;
      }

      if (response?.Status === 1 && response?.Data?.Info?.Status == "2") {
        setUserData(
          { token: response.Data.AccessToken, userInfo: response.Data.Info },
          false
        );
        setstage("basicInfo");
        return;
      }

      message.error("Unexpected response. Please try again.");
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const onSubmitLogin = async (values) => {
    const {setCompany} = Company
    setLoading(true);
    try {
      const response = await Login(values.email, values.password);

      if (response?.Status === -1) {
        signOutEvent();
        message.error("Session expired. Please try again.");
        return;
      }

      if (response?.Status === 0) {
        message.error(response?.Error || "Login failed");
        return;
      }

      if (response?.Status === 1 && response?.Data?.Info?.Status === "1") {
        message.success("Signed In Successfully");
        setUserData({
          token: response.Data.AccessToken,
          userInfo: response.Data.Info,
        });

        onClose(true);
        const Employer = response && response?.Data && response?.Data?.Info && response?.Data?.Info?.Employer
        if (router.pathname.includes("/employer") && parseInt(Employer) === 1) {
          const rawCompanies = response && response?.Data && response?.Data?.Info && response?.Data?.Info?.TotalEmployeeCompany;
          const companies = rawCompanies && rawCompanies?.length > 0 ? rawCompanies : [];
          if (companies.length > 1) {
            setCookie("companies", JSON.stringify(companies) || "", { maxAge: 60 * 60 * 24 * 7 });
            router.push("/employer/my-companies");
          } else if (companies.length === 1) {
            setCompany(companies[0], false);
            router.push("/employer/home");
          } else {
            router.push("/employer/home");
          }
        } else if (link) {
          handleApplyNow(JobCode);
          window.open(link, openNewTab ? "_blank" : "_self");
        }
        return;
      }

      if (response?.Status === 1 && response?.Data?.Info?.Status == "2") {
        setUserData(
          {
            token: response.Data.AccessToken,
            userInfo: response.Data.Info,
          },
          false
        );
        setstage("basicInfo");
        return;
      }

      message.error("Unexpected login response. Please try again.");
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onForgotPassword = async (values) => {
    const emailAddress = values?.EmailAddress?.trim();
    setLoading(true);
    try {
      const response = await VerifyEmailForResetPassword(emailAddress);
      if (response?.Status === -1) {
        signOutEvent();
        return;
      }
      if (response?.Status === 0) {
        message.error(response?.Error || "Unable to send reset code");
        return;
      }
      setEmail(emailAddress);
      setResetFieldsUnlocked(false);
      setstage("forgotVerify");
      message.success("A password reset code has been sent to your email.");
    } catch (err) {
      message.error(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onResetPassword = async (values) => {
    setLoading(true);
    try {
      const response = await ResetPassword({
        ...values,
        EmailAddress: email,
      });
      if (response?.Status === -1) {
        signOutEvent();
        return;
      }
      if (response?.Status === 0) {
        message.error(response?.Error || "Unable to reset password");
        return;
      }
      message.success("Password changed successfully");
      setstage("login");
    } catch (err) {
      message.error(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderForgotPassword = () => (
    <div className={classes.authContent}>
      <div className={classes.authHeader}>
        <span className={classes.eyebrow}>Account Recovery</span>
        <UIHeading level={2}>Forgot your password?</UIHeading>
        <UIText>Enter your email and we will send you a secure reset code.</UIText>
      </div>
      <Form layout="vertical" onFinish={onForgotPassword}>
        <Form.Item
          label="Email address"
          name="EmailAddress"
          rules={[
            { type: "email", message: "Please enter a valid email address" },
            { required: true, message: "Please enter your email address" },
          ]}
        >
          <Input
            autoFocus
            type="email"
            autoComplete="email"
            placeholder="you@example.com"
            className={classes.signupEmailInput}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <UIButton
            htmlType="submit"
            loading={loading}
            className={classes.contine}
          >
            Send reset code
          </UIButton>
        </Form.Item>
      </Form>
      <button className={classes.backButton} onClick={() => setstage("login")}>
        ← Back to sign in
      </button>
    </div>
  );

  const renderResetPassword = () => (
    <div className={classes.authContent}>
      <div className={classes.authHeader}>
        <span className={classes.eyebrow}>Secure Reset</span>
        <UIHeading level={2}>Create a new password</UIHeading>
        <UIText>Enter the code sent to {email} and choose a strong new password.</UIText>
      </div>
      <Alert
        message="Reset code sent"
        type="success"
        showIcon
        className={classes.resetAlert}
      />
      <Form layout="vertical" autoComplete="off" onFinish={onResetPassword}>
        <Form.Item
          label="Reset code"
          name="PasswordResetCode"
          rules={[{ required: true, message: "Please enter your reset code" }]}
        >
          <Input
            autoComplete="one-time-code"
            inputMode="numeric"
            readOnly={!resetFieldsUnlocked}
            onFocus={() => setResetFieldsUnlocked(true)}
            data-lpignore="true"
            data-1p-ignore="true"
            data-form-type="other"
            placeholder="Enter the code from your email"
            className={classes.signupEmailInput}
          />
        </Form.Item>
        <Form.Item
          label="New password"
          name="NewPassword"
          rules={[{ required: true, message: "Please enter a new password" }]}
        >
          <Input.Password
            placeholder="New password"
            autoComplete="new-password"
            readOnly={!resetFieldsUnlocked}
            onFocus={() => setResetFieldsUnlocked(true)}
            data-lpignore="true"
            data-1p-ignore="true"
            className={classes.signupEmailInput}
          />
        </Form.Item>
        <Form.Item
          label="Confirm new password"
          name="ConfirmNewPassword"
          dependencies={["NewPassword"]}
          rules={[
            { required: true, message: "Please confirm your new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return !value || getFieldValue("NewPassword") === value
                  ? Promise.resolve()
                  : Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Confirm new password"
            autoComplete="new-password"
            readOnly={!resetFieldsUnlocked}
            onFocus={() => setResetFieldsUnlocked(true)}
            data-lpignore="true"
            data-1p-ignore="true"
            className={classes.signupEmailInput}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <UIButton htmlType="submit" loading={loading} className={classes.contine}>
            Update password
          </UIButton>
        </Form.Item>
      </Form>
      <button className={classes.backButton} onClick={() => setstage("forgot")}>
        ← Use a different email
      </button>
    </div>
  );

  const renderSignUpButton = () => {
    return (
        <div className={classes.authContent}>
          <div className={classes.authHeader}>
            <span className={classes.eyebrow}>Join HireSide</span>
            <UIHeading level={2}>Build your career profile</UIHeading>
            <UIText>Create your candidate account and let the right opportunities find you.</UIText>
          </div>
          <div>
            <div className={classes.fieldGroup}>
              <label>Email address</label>
              <Input
                type="email"
                className={classes.signupEmailInput}
                placeholder="you@example.com"
                ref={inputRef}
                autoComplete="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
          </div>
          <div className={classes.primaryAction}>
            <UIButton
              level="s"
              type="primary"
              loading={loading}
              onClick={onSignUp}
              className={classes.contine}
            >
              Continue with email
            </UIButton>
            {/* <div className={classes.divider}>
              <span>or continue with</span>
            </div>
            <GetLogin onLogin={onSignUpwithSocial} /> */}
          </div>
          <div className={classes.switchPrompt}>
            Already have an account?{" "}
            <UILink onClick={() => setstage("login")}>Sign in</UILink>
          </div>
        </div>
    );
  };

  const renderConfirmEmail = () => {
    return (
      <>
        <div className={classes.authContent}>
          <div className={classes.authHeader}>
            <span className={classes.eyebrow}>Email Verification</span>
            <UIHeading level={2}>Check your inbox</UIHeading>
            <UIText
              level={1}
            >{`Enter the verification code sent to ${email}.`}</UIText>
          </div>
          <div className={classes.fieldGroup}>
            <label>Verification code</label>
            <Input
              placeholder="Enter verification code"
              autoFocus={true}
              className={classes.signupEmailInput}
              onChange={(e) => setverificationCode(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onVerify();
                }
              }}
            />
            {seconds == 0 ? (
              <div className={classes.resendRow}><UILink onClick={onSignUp}>Resend code</UILink></div>
            ) : (
              <div
                style={{
                  textAlign: "right", marginTop: 10,
                }}
              >
                <UIText>Resend available in {seconds}s</UIText>
              </div>
            )}
          </div>
          <div className={classes.actionRow}>
            <UIButton
              type="secondary"
              onClick={() => {
                setstage("email");
                setSeconds(0);
              }}
              className={classes.secondaryButton}
            >
              Cancel
            </UIButton>
            <div className={classes.actionGrow}>
              <UIButton
                loading={loading}
                onClick={() => onVerify()}
                className={classes.contine}
              >
                Verify
              </UIButton>
            </div>
          </div>
        </div>
      </>
    );
  };

  const onSignOut = () => {
    signOutEvent();
    singOut();
    onClose();
    setstage("email");
    setEmail("");
    router.push("/");
  };

  const changeResumeUploader = async (response) => {

    const resumeFields = {};
    if (response?.Status === 1) {
      if (fields[2]["Fields"][1]["DataType"] == "Email" && (fields[2]["Fields"][1]["DefaultValue"])) {
        resumeFields["hs_ea"] = fields[2]["Fields"][1]["DefaultValue"];
        resumeFields["FileName"] = response?.Data?.Files?.FileName;
        const res = await onFinishBasicInfoForm(resumeFields);
      }
    }
  }

  const { Dragger } = Upload;
  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  const UIResumeUploader = ({ onChange
  }) => {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [imgName, setImgName] = useState("");
    const beforeUpload = (file) => {

      const isLt20M = file.size / 1024 / 1024 < 20; // --->> 20 used for 20MB
      if (!isLt20M) {
        message.error("PDF must smaller than 20MB!");
      }
      return isLt20M ? true : Upload.LIST_IGNORE;
    };

    const handleChange = async ({ fileList }) => {
      if (fileList.length === 0) {
        setList([]);
        return;
      }
      setList(fileList);
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", fileList[0]?.originFileObj);
        const res = await uploadFile(formData);
        if (res?.Status === 1) {
          onChange(res);
          setImgName(fileList[0]?.name || "");
        } else {
          message.error(res?.Error || "Upload failed");
        }
    } catch (err) {
      message.error(  err?.message || "Somthing went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    const props = {
      name: "file",
      multiple: false,
      // action: "",
    };

    return (
      <div style={{ width: "100%" }}>
        <Dragger
          {...props}
          name="file"
          maxCount={1}
          fileList={list}
          showUploadList={false}
          onChange={handleChange}
          beforeUpload={beforeUpload}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start', // Align items to the left
            textAlign: 'left', // Align text to the left
            marginBottom: '0px',
          }}

        >
          <p className="ant-upload-drag-icon" style={{ marginBottom: "-16px", }}>
            <span style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              {loading ? <Spin indicator={antIcon} /> : <FilePdfOutlined width={55} style={{ fontSize: "60px" }} />}
              <span style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "baseline",
              }}> <span
                style={{ marginLeft: "10px", fontWeight: "500", fontSize: "x-large" }} > Auto  Create Profile via Resume  </span>
                <span className="ant-upload-hint" style={{ fontWeight: 400 }}>
                  Click here to upload your resume
                </span>
              </span>
            </span>

          </p>

          {imgName ? (
            <div
              style={{
                marginTop: "30px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <p className="ant-upload-hint">
                <FileOutlined style={{ fontSize: 20 }} />
              </p>
              <p
                style={{ marginLeft: 10, fontSize: 20 }}
                className="ant-upload-hint"
              >
                {imgName}
              </p>
            </div>
          ) : (
            <p className="ant-upload-hint"></p>
          )}
        </Dragger>
      </div>
    );
  };
  const renderUserInfo = () => {

    const userInfo = getUserInfo();

    return (
        <div className={`${classes.authContent} ${classes.profileSetup}`}>
          <div className={classes.authHeader}>
            <span className={classes.eyebrow}>Almost there</span>
            <UIHeading level={2}>Complete your profile</UIHeading>
            <UIText>
              Add a few details so employers can discover the right fit for you.
            </UIText>
          </div>
          {userInfo?.Employer == 0 && (
            <>
              <div className={classes.resumeCard}>
                <UIResumeUploader onChange={changeResumeUploader} />
              </div>
              <Divider className={classes.profileDivider} plain>
                or enter details manually
              </Divider>
            </>
          )}
          <div className={classes.profileForm}>
            <UIFormNew
              source="CandidateSignUp"
              fields={fields}
              requiredMark={true}
              buttonLoding={loading}
              size="large"
              onSubmitPress={(a) => {
                onFinishBasicInfoForm(a);
              }}
            />
          </div>
        </div>
    );
  };

  const renderPassword = () => {
    return (
      <>
        <div className={classes.authContent}>
          <div className={classes.authHeader}>
            <span className={classes.eyebrow}>Welcome Back</span>
            <UIHeading level={2}>Enter your password</UIHeading>
            <UIText>Continue securely with {email}.</UIText>
          </div>
          <Form
            name="password_form"
            className="login-form"
            initialValues={{ remember: true }}
            layout="vertical"
            onFinish={onFinisPassowrdForm}
          >
            <Form.Item
              name="password"
              label="Password"
              rules={[
                { required: true, message: "Please input Your password" },
              ]}
            >
              <Input.Password
                className={classes.signupEmailInput}
                placeholder="Enter your password"
                autoFocus={true}
              />
            </Form.Item>

            <UILink
              onClick={() => {
                setstage("forgot");
              }}
            >
              Forgot Password?
            </UILink>
            <div className={classes.actionRow}>
              <UIButton
                type="secondary"
                onClick={() => {
                  setstage("email");
                }}
              >
                Cancel
              </UIButton>
              <div className={classes.actionGrow}>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    className={classes.contine}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </div>
            </div>
          </Form>
        </div>
      </>
    );
  };

  // const renderEmployer = () => {

  //   return (
  //     <AddCompany
  //       formloding={Companyloading}
  //       onAddCompany={onAddCompany}
  //       addCompanyfields={companyFields}
  //     />
  //   );
  // }

  return (
    <div className="ModalBox">

      <Modal

        mask={{ closable: false }}
        centered
        open={visible}
        onCancel={() => {
          stage === "email" && setstage("login");
          stage === "password" && router.reload();
          stage === "employer" && router.reload();
          stage !== "basicInfo" && onClose(false);
          stage == "basicInfo" && message.error('Please complete the profile form and click save');
        }}
        footer={false}
        style={{ margin: "auto" }}
        destroyOnHidden={true}
        width={620}
        border={0}
        className={`${classes.modalShell} ${
          stage === "basicInfo" ? classes.profileModalShell : ""
        }`}
        styles={{
          body: {
            display: "flex",
            justifyContent: "center",
          },
        }}
      >
        <div
          key={stage}
          className={`${classes.stageTransition} ${
            stage === "basicInfo" || stage === "forgotVerify"
              ? classes.stageScrollable
              : classes.stageCentered
          } ${stage === "forgotVerify" ? classes.resetStage : ""} ${
            stage === "basicInfo" ? classes.profileStage : ""
          }`}
        >
          {stage === "email" && renderSignUpButton()}
          {stage === "verification" && renderConfirmEmail()}
          {stage === "basicInfo" && renderUserInfo()}
          {stage === "password" && renderPassword()}
          {stage === "forgot" && renderForgotPassword()}
          {stage === "forgotVerify" && renderResetPassword()}
          {stage === "login" && <RenderLogin {...{
            setstage,
            onSubmitLogin,
            classes,
            visible,
            loading,
            onClose
          }} />}
        </div>
        {/* {stage === "employer" && renderEmployer()} */}
      </Modal>
    </div>

  );
}

const useStyles = createUseStyles({
  signupEmailInput: {
    maxWidth: "100%",
    height: 48,
    background: "#f8fbff",
    border: "1px solid #d8e4ef",
    fontSize: 15,
    borderRadius: 10,
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#0c64ae",
    },
    "&:focus": {
      borderColor: "#0c64ae",
      boxShadow: "0 0 0 3px rgba(12, 100, 174, 0.1)",
    },
  },
  emailInput: {
    maxWidth: 500,
    height: 40,
    border: "1px solid #d9d9d9",
    fontSize: "16px",
    borderRadius: 5,
    "&:hover": {
      border: "1px solid #0c64ae",
    },
    "&:focus": {
      border: "1px solid #0c64ae",
    },
  },
  button: {
    width: "100%",
    background: "#fff",
    height: 40,
    borderRadius: 5,
    border: "1px solid #d9d9d9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "10px 0px",
  },
  signup: {
    width: "100%",
    background: "#0c64ae",
    height: 40,
    borderRadius: 5,
    border: "1px solid #d9d9d9",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "10px 0px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  contine: {
    width: "100%",
    height: 48,
    borderRadius: 10,
    marginTop: 0,
    padding: "0 20px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    background: "#0c64ae",
    color: "#fff",
    border: "none",
    boxShadow: "0 8px 20px rgba(12, 100, 174, 0.22)",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1,
    transition: "all 0.2s ease",
    "&:hover, &:focus": {
      background: "#095a9e !important",
      color: "#fff !important",
      transform: "translateY(-1px)",
      boxShadow: "0 10px 24px rgba(12, 100, 174, 0.28)",
    },
  },
  modalShell: {
    "& .ant-modal-content": {
      overflow: "hidden",
      padding: 0,
      borderRadius: 22,
      border: "1px solid rgba(12, 100, 174, 0.1)",
      background: `
        radial-gradient(circle at 100% 0%, rgba(96, 165, 250, 0.12), transparent 34%),
        #fff
      `,
      boxShadow: "0 28px 80px rgba(15, 55, 95, 0.22)",
    },
    "& .ant-modal-close": {
      top: 16,
      insetInlineEnd: 16,
      borderRadius: "50%",
      background: "#f1f6fb",
      color: "#486581",
    },
    "& .ant-modal-body": {
      height: 560,
      padding: "28px 56px 20px",
      alignItems: "center",
      perspective: 1400,
      overflow: "hidden",
    },
    "& .ant-form-item-label > label": {
      color: "#334e68",
      fontWeight: 600,
    },
    "@media(max-width: 640px)": {
      margin: "12px auto",
      maxWidth: "calc(100vw - 24px)",
      "& .ant-modal-body": {
        height: "min(540px, calc(100vh - 32px))",
        padding: "24px 20px 18px",
      },
    },
  },
  profileModalShell: {
    "& .ant-modal-body": {
      width: "100%",
      height: "auto",
      minHeight: 0,
      padding: "40px 56px 36px",
      overflow: "visible",
    },
    "@media(max-width: 640px)": {
      "& .ant-modal-body": {
        height: "auto",
        padding: "38px 20px 26px",
      },
    },
  },
  stageTransition: {
    width: "100%",
    height: "100%",
    padding: "2px 4px",
    overflowX: "hidden",
    overflowY: "auto",
    animation: "$authStageFlip 0.62s cubic-bezier(0.22, 1, 0.36, 1)",
    transformStyle: "preserve-3d",
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden",
    scrollbarWidth: "thin",
    scrollbarColor: "#c6d8e8 transparent",
    "&::-webkit-scrollbar": { width: 5 },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 999,
      background: "#c6d8e8",
    },
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  stageCentered: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stageScrollable: {
    display: "block",
  },
  profileStage: {
    height: "auto",
    padding: 0,
    overflow: "visible",
  },
  resetStage: {
    paddingTop: 0,
    paddingBottom: 0,
    "& $authHeader": {
      marginBottom: 10,
    },
    "& $authHeader h2": {
      marginTop: "6px !important",
      marginBottom: "5px !important",
      fontSize: "26px !important",
    },
    "& $authHeader p": {
      lineHeight: 1.4,
    },
    "& $resetAlert": {
      marginBottom: 10,
      padding: "6px 12px",
    },
    "& .ant-form-item": {
      marginBottom: 8,
    },
    "& $signupEmailInput": {
      height: 42,
    },
    "& $contine": {
      height: 44,
    },
    "& $backButton": {
      marginTop: 16,
    },
  },
  "@keyframes authStageFlip": {
    "0%": {
      opacity: 0,
      transform: "rotateY(88deg) scale(0.97)",
    },
    "55%": { opacity: 0.65 },
    "100%": {
      opacity: 1,
      transform: "rotateY(0deg) scale(1)",
    },
  },
  authContent: {
    width: "100%",
    maxWidth: 450,
    margin: "0 auto",
  },
  profileSetup: {
    maxWidth: 470,
    textAlign: "left",
    "& $authHeader": {
      marginBottom: 22,
    },
  },
  resumeCard: {
    "& .ant-upload-wrapper .ant-upload-drag": {
      minHeight: 116,
      padding: "14px 16px",
      border: "1px dashed #8fb9df",
      borderRadius: 12,
      background: "#f7fbff",
      transition: "all 0.2s ease",
    },
    "& .ant-upload-wrapper .ant-upload-drag:hover": {
      borderColor: "#0c64ae",
      background: "#eff7ff",
    },
    "& .ant-upload-drag-icon": {
      width: "100%",
      margin: "0 !important",
    },
    "& .ant-upload-drag-icon > span": {
      alignItems: "center !important",
    },
    "& .anticon-file-pdf": {
      color: "#0c64ae",
      fontSize: "38px !important",
    },
    "& .ant-upload-drag-icon span span span:first-child": {
      marginLeft: "12px !important",
      color: "#102a43",
      fontSize: "16px !important",
      fontWeight: "600 !important",
    },
    "& .ant-upload-hint": {
      marginLeft: 12,
      color: "#627d98 !important",
      fontSize: "13px !important",
    },
  },
  profileDivider: {
    margin: "20px 0 !important",
    color: "#829ab1 !important",
    fontSize: "12px !important",
  },
  profileForm: {
    "& .ant-form-item": {
      marginBottom: 16,
    },
    "& .ant-form-item-label > label": {
      color: "#334e68",
      fontSize: 14,
      fontWeight: 600,
    },
    "& .ant-form-item-label > label > span": {
      fontSize: "14px !important",
      fontWeight: "600 !important",
    },
    "& .ant-input, & .ant-input-affix-wrapper, & .ant-select-selector": {
      borderColor: "#d8e4ef !important",
      borderRadius: "10px !important",
      background: "#f8fbff !important",
      boxShadow: "none !important",
    },
    "& .ant-input:hover, & .ant-input-affix-wrapper:hover, & .ant-select-selector:hover": {
      borderColor: "#0c64ae !important",
    },
    "& .ant-select": {
      height: "46px !important",
      marginBottom: "0 !important",
    },
    "& .ant-select.ant-select-outlined > .ant-select-selector": {
      height: "46px !important",
      minHeight: "46px !important",
      padding: "0 12px !important",
      display: "flex !important",
      alignItems: "center !important",
      border: "1px solid #d8e4ef !important",
      borderRadius: "10px !important",
      background: "#f8fbff !important",
      boxShadow: "none !important",
    },
    "& .ant-select.ant-select-focused > .ant-select-selector": {
      borderColor: "#0c64ae !important",
      boxShadow: "0 0 0 3px rgba(12, 100, 174, 0.1) !important",
    },
    "& .ant-select-selection-item, & .ant-select-selection-placeholder": {
      lineHeight: "44px !important",
      color: "#334e68",
      fontSize: "15px !important",
      fontWeight: "400 !important",
    },
    "& button[type='submit']": {
      minWidth: 180,
      height: 46,
      border: 0,
      borderRadius: "10px !important",
      background: "#0c64ae !important",
      boxShadow: "0 8px 20px rgba(12, 100, 174, 0.2)",
      fontWeight: 600,
    },
  },
  authHeader: {
    marginBottom: 30,
    textAlign: "left",
    "& h2": {
      margin: "9px 0 8px !important",
      color: "#102a43 !important",
      fontSize: "32px !important",
      fontWeight: "700 !important",
      letterSpacing: "-0.5px",
      lineHeight: "1.2 !important",
    },
    "& p": {
      margin: 0,
      color: "#627d98",
      fontSize: 15,
      lineHeight: 1.6,
    },
  },
  eyebrow: {
    display: "inline-flex",
    padding: "5px 10px",
    borderRadius: 999,
    background: "#eaf4ff",
    color: "#0c64ae",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
  authLinks: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    margin: "-4px 0 22px",
    flexWrap: "wrap",
  },
  primaryAction: {
    width: "100%",
    marginTop: 24,
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    textAlign: "left",
    "& label": {
      color: "#334e68",
      fontSize: 14,
      fontWeight: 600,
    },
  },
  divider: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    margin: "26px 0",
    color: "#829ab1",
    fontSize: 12,
    "&:before, &:after": {
      content: "''",
      height: 1,
      flex: 1,
      background: "#e4edf5",
    },
  },
  switchPrompt: {
    display: "flex",
    justifyContent: "center",
    gap: 4,
    marginTop: 26,
    textAlign: "center",
    color: "#627d98",
    fontSize: 14,
  },
  actionRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 24,
  },
  actionGrow: { flex: 1 },
  secondaryButton: {
    height: 48,
    borderRadius: 10,
  },
  resendRow: { marginTop: 10, textAlign: "right" },
  resetAlert: {
    marginBottom: 22,
    borderRadius: 10,
  },
  backButton: {
    display: "block",
    margin: "22px auto 0",
    padding: 0,
    border: 0,
    background: "transparent",
    color: "#0c64ae",
    cursor: "pointer",
    fontSize: 14,
  },
  image: {
    width: "60%",
    "@media(max-width:400px)": {
      width: "100%",
    },
    "@media(max-width:600px)": {
      width: "70%",
    },
  },
});

export default SignUpPopup;
